import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFoetex = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 128 128",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 120,
		height: 125,
		x: 4.5,
		y: 1.5,
		fill: "var(--background-color, #0F223B)",
		stroke: "var(--border-color, #0F223B)",
		strokeWidth: 3,
		rx: 43.5
	}), /* @__PURE__ */ _jsx("path", {
		fill: "var(--font-color, white)",
		d: "M70.597 45.739h5.692v-7.002H61.614s-1.145 0-2.303 1.621c-1.118 1.522-1.118 4.593-1.118 4.593v9.005H50.16v6.003h8.033v28.038H69.29V59.96h7v-6.003h-7V47.12s0-.611.504-1.032c.515-.403.804-.35.804-.35"
	})]
});
export default SvgIconFoetex;
